import { CButton, CCol, CLabel, CRow } from "@coreui/react";
import React, { useState } from "react";
import Auth from "src/auth";
import ModelRefundHistory from "./ModelRefundHistory";
import { formatDateTime } from "src/shared/Format/dateFormat";

const LotListViewTransferRefund = (props) => {
  const { authenticated } = Auth();
  const [refundopen, setrefundopen] = useState(false);
  const [refundType, setrefundType] = useState(0);
  const [transferFormUserId, setTransferFormUserId] = useState(0);
  const [transferCount, setTransferCount] = useState(0);

  const handleRefundPopupClose = () => {
    setrefundopen(false);
    setrefundType(0);
    setTransferFormUserId(0);
    setTransferCount(0);
  };

  const ShowRefundHistory = (
    tenderId,
    lotNo,
    refundType,
    transferFormUserId,
    transferCount
  ) => {
    setrefundopen(true);
    setrefundType(refundType);
    setTransferFormUserId(transferFormUserId);
    setTransferCount(transferCount);
  };
  return (
    <>
      {/* Start Transfer EMD Refund */}
      {(authenticated.role === "CFO" || authenticated.role === "CGMF") &&
      props.viewListDetails.islottransferd &&
      props.viewListDetails.transferEMDBeneficiaryDetails1 !== "" ? (
        <>
          <CRow className="pl-1 pr-1 mt-3">
            <CCol xl={12} className="mb-2">
              <strong> Lot Tranfer EMD Refund</strong>

              <hr></hr>
              <CLabel>
                (Note: If you have any doubts or discrepancies regarding issuing
                a refund to the vendor, please contact the head office, as you
                are fully responsible for providing the refund to the vendor.)
              </CLabel>
            </CCol>
          </CRow>

          <CRow className="pl-1 pr-1 ">
            <CCol xl={12} className="mb-2">
              <b>Transfer 1</b>
            </CCol>
            <CCol xl={12} className="mb-2">
              {props.viewListDetails.transferEMDBeneficiaryDetails1}
            </CCol>
            <CCol xl={12} className="mb-2">
              {props.viewListDetails.transferEMDRefundStatusDetails1}
            </CCol>

            <CCol xl={12} className={"mb-2"}>
              {props.viewListDetails.isTransfer1EMDRefund10perGenerated && (
                <CButton
                  color="info"
                  className=" ml-2 mr-2 "
                  onClick={() => {
                    ShowRefundHistory(
                      props.viewListDetails.tenderId,
                      props.viewListDetails.lotNo,
                      1,
                      props.viewListDetails.transferFormUserId1,
                      1
                    );
                  }}
                >
                  View 10% Refund Status
                </CButton>
              )}
              {props.viewListDetails.isTransfer1EMDRefund15perGenerated && (
                <CButton
                  color="info"
                  className=" ml-2 mr-2 "
                  onClick={() => {
                    props.ShowRefundHistory(
                      props.viewListDetails.tenderId,
                      props.viewListDetails.lotNo,
                      5,
                      props.viewListDetails.transferFormUserId1,
                      1
                    );
                  }}
                >
                  View 15% Refund Status
                </CButton>
              )}
            </CCol>
            {props.viewListDetails.transferEMDBeneficiaryDetails2 !== "" && (
              <>
                <CCol
                  xl={12}
                  className="mb-2"
                  // hidden={
                  //   props.viewListDetails.transferEMDBeneficiaryDetails2 === ""
                  //     ? true
                  //     : false
                  // }
                >
                  <b>Transfer 2</b>
                  <hr></hr>
                </CCol>
                <CCol
                  xl={12}
                  className="mb-4"
                  // hidden={
                  //   props.viewListDetails.transferEMDBeneficiaryDetails2 === ""
                  //     ? true
                  //     : false
                  // }
                >
                  {props.viewListDetails.transferEMDBeneficiaryDetails2}
                </CCol>
                {props.viewListDetails.transferEMDRefundStatusDetails2 !==
                  "" && (
                  <CCol
                    xl={12}
                    className="mb-4"
                    // hidden={
                    //   props.viewListDetails.transferEMDRefundStatusDetails2 ===
                    //   ""
                    //     ? true
                    //     : false
                    // }
                  >
                    {props.viewListDetails.transferEMDRefundStatusDetails2}
                  </CCol>
                )}
              </>
            )}

            <CCol xl={12} className="mb-4">
              <CButton
                color="info"
                className=" ml-1 mr-1 mb-2"
                hidden={
                  props.showEMDRefundButton ? false : true
                  //props.viewListDetails.props.showEMDRefundButton ? false : true
                }
                // onClick={() =>
                //   InitiateTransferEMDRefund(
                //     props.viewListDetails.lotId,
                //     props.viewListDetails.userId,
                //     props.viewListDetails.isEMDRefundFileCancelled
                //   )
                // }
                onClick={() =>
                  props.RefundConfirmationPopupHandler(
                    6,
                    1,
                    "Are you sure you want to proceed for Refund?",
                    props.viewListDetails.lotId,
                    props.viewListDetails.lotNo,
                    props.viewListDetails.tenderId,
                    props.viewListDetails.userId,
                    0,
                    props.viewListDetails.isEMDRefundFileCancelled
                  )
                }
              >
                Generate Refund Files
              </CButton>

              {props.viewListDetails.isTransfer2EMDRefund10perGenerated && (
                <CButton
                  color="info"
                  className=" ml-2 mr-2 "
                  onClick={() => {
                    ShowRefundHistory(
                      props.viewListDetails.tenderId,
                      props.viewListDetails.lotNo,
                      1,
                      props.viewListDetails.transferFormUserId2,
                      2
                    );
                  }}
                >
                  View 10% Refund Status
                </CButton>
              )}
              {props.viewListDetails.isTransfer2EMDRefund15perGenerated && (
                <CButton
                  color="info"
                  className=" ml-2 mr-2 "
                  onClick={() => {
                    ShowRefundHistory(
                      props.viewListDetails.tenderId,
                      props.viewListDetails.lotNo,
                      5,
                      props.viewListDetails.transferFormUserId2,
                      2
                    );
                  }}
                >
                  View 15% Refund Status
                </CButton>
              )}
            </CCol>
          </CRow>
        </>
      ) : (
        <></>
      )}
      {/* End Transfer EMD Refund */}
      {/* Start Refund Installment Adjustment Amount */}

      {/*authenticated.role === "DFO" &&
      "isRequiredToReturnAdjustmentAmt:" +
        props.viewListDetails.isRequiredToReturnAdjustmentAmt
        ? " true 11" + props.viewListDetails.isRequiredToReturnAdjustmentAmt
        : "false 11"}
      */}
      {authenticated.role === "DFO" &&
        //props.viewListDetails.isRequiredToReturnAdjustmentAmt > 0 &&
        props.viewListDetails.isRequiredToReturnAdjustmentAmt && (
          <>
            <CRow className="pl-1 pr-1 mt-5">
              <CCol xl={12} className="mb-2">
                <strong>Refund Installment Adjustment Amount</strong>
                <hr></hr>
              </CCol>
            </CRow>
            <CRow className="pl-1 pr-1 ">
              <CCol xl={9} className="mb-2">
                <b>{props.viewListDetails.refundAdjustmentNotes}</b>
              </CCol>
              <CCol xl={3} className="mb-2">
                <CButton
                  color="info"
                  className=" ml-2 mr-2 mb-2"
                  disabled={
                    props.disableInstallmentAdjustment
                    // props.viewListDetails.disableInstallmentAdjustment
                    //   ? true
                    //   : false
                  }
                  // onClick={() =>
                  //   InitiateRefund(
                  //     props.viewListDetails.lotId,
                  //     7,
                  //     props.viewListDetails.lotNo,
                  //     props.viewListDetails.tenderId
                  //   )
                  // }
                  onClick={() =>
                    props.RefundConfirmationPopupHandler(
                      7,
                      1,
                      "Are you sure you want to proceed for Refund?",
                      props.viewListDetails.lotId,
                      props.viewListDetails.lotNo,
                      props.viewListDetails.tenderId,
                      props.viewListDetails.userId,
                      7,
                      props.viewListDetails.isEMDRefundFileCancelled
                    )
                  }
                >
                  Approve Refund
                </CButton>
                <CButton
                  color="info"
                  className=" ml-2 mr-2 mb-2"
                  hidden={
                    props.viewListDetails.refundAdjustmentApprovedByDFO === true
                      ? false
                      : true
                  }
                  onClick={() => {
                    ShowRefundHistory(
                      props.viewListDetails.tenderId,
                      props.viewListDetails.lotNo,
                      7
                    );
                  }}
                >
                  View Refund Status
                </CButton>
              </CCol>
            </CRow>
          </>
        )}
      {/* End 5 % Security Deposite Refund */}
      {/* Start 5 % Security Deposite Refund */}
      {authenticated.role === "DFO" &&
      props.viewListDetails.is5PerAmtRefundRequested === true &&
      ((props.viewPaymentSlotsData[props.viewPaymentSlotsData.length - 1]
        .add5PerOnFinalAmount > 0 
        ) ||
        (props.viewListDetails.isSDAmountPaidOnline &&
          props.FullPaymentLotDetails.add5PerOnFinalAmount > 0 &&
          props.FullPaymentLotDetails.isFullPaymentDone)) ? (
        <>
          <CRow className="pl-1 pr-1 mt-5">
            <CCol xl={12} className="mb-2">
              <strong>Refund 5 % Security Deposite Amount</strong>
              <hr></hr>
            </CCol>
          </CRow>
          <CRow className="pl-1 pr-1 ">
            <CCol xl={8} className="mb-2">
              Refund Security Deposit Amount before 15 days of request. Amount :
              &nbsp;
              <b>


            {(props.FullPaymentLotDetails.add5PerOnFinalAmount > 0 &&
        props.FullPaymentLotDetails.isFullPaymentDone) 
        ? Math.ceil(props.FullPaymentLotDetails.add5PerOnFinalAmount) :
          Math.ceil(props.viewPaymentSlotsData[props.viewPaymentSlotsData.length - 1]
      .add5PerOnFinalAmount)
          }


               
              </b>
              <br /> Refund Request Date : &nbsp;
              <b>
                {formatDateTime(props.viewListDetails.refundRequestDateTime)}
              </b>
            </CCol>
            <CCol xl={4} className="mb-2">
              <CButton
                color="info"
                className=" ml-2 mr-2 mb-2"
                disabled={
                  props.disable5PerRefundButton
                  //viewListDetails.disable5PerRefundButton ? true : false
                }
                // onClick={() =>
                //   InitiateRefund(
                //     viewListDetails.lotId,
                //     4,
                //     viewListDetails.lotNo,
                //     viewListDetails.tenderId
                //   )
                // }
                onClick={() =>
                  props.RefundConfirmationPopupHandler(
                    7,
                    1,
                    "Are you sure you want to proceed for Refund?",
                    props.viewListDetails.lotId,
                    props.viewListDetails.lotNo,
                    props.viewListDetails.tenderId,
                    props.viewListDetails.userId,
                    4,
                    props.viewListDetails.isEMDRefundFileCancelled
                  )
                }
              >
                Approve Refund
              </CButton>
              {props.viewListDetails.is5PerAmtRefundRequested === true &&
                props.IsSDRefunded5Per === true && (
                  <CButton
                    color="info"
                    className=" ml-2 mr-2 mb-2"
                    onClick={() => {
                      props.ShowRefundHistory(
                        props.viewListDetails.tenderId,
                        props.viewListDetails.lotNo,
                        4
                      );
                    }}
                  >
                    View Refund Status
                  </CButton>
                )}
            </CCol>
          </CRow>
        </>
      ) : (
        ""
      )}
      {/* End 5 % Security Deposite Refund */}
      {/* Nikita: Start Refund Security Deposite */}
      {authenticated.role === "DFO" &&
        props.viewListDetails.actualQuantity === 0 && (
          <>
            <CRow className="pl-1 pr-1 mt-5">
              <CCol xl={12} className="mb-2">
                <strong>
                  Refund Security Deposite Amount (in case of actualy quantity
                  is zero.)
                </strong>
                <hr></hr>
              </CCol>
            </CRow>
            {/* {props.viewListDetails.islottransferd
            ? "islottransferd :True"
            : "islottransferd:False"} */}
            <CRow className="pl-1 pr-1">
              <CCol
                className="col-2"
                hidden={
                  !props.viewListDetails.islottransferd
                    ? false
                    : props.viewListDetails.lottransfer25emdpaymentCompleted
                    ? true
                    : props.viewListDetails.lottransfer10emdpaymentCompleted
                    ? false
                    : true
                }
                // hidden={
                //   props.viewListDetails.lottransfer25emdpaymentCompleted
                //     ? true
                //     : false
                // }
              >
                <strong className="ml-2">
                  Amount : {props.viewListDetails.amount10}
                </strong>
                <br />
                <CButton
                  className="mt-2 ml-2 mr-2 mb-2"
                  color="success"
                  variant="outline"
                  disabled={
                    props.disableEMDRefundButton
                    // props.viewListDetails.disableEMDRefundButton ? true : false
                  }
                  // onClick={() =>
                  //   InitiateRefund(
                  //     props.viewListDetails.lotId,
                  //     2,
                  //     props.viewListDetails.lotNo,
                  //     props.viewListDetails.tenderId
                  //   )
                  // }
                  onClick={() =>
                    props.RefundConfirmationPopupHandler(
                      7,
                      1,
                      "Are you sure you want to proceed for Refund?",
                      props.viewListDetails.lotId,
                      props.viewListDetails.lotNo,
                      props.viewListDetails.tenderId,
                      props.viewListDetails.userId,
                      2,
                      props.viewListDetails.isEMDRefundFileCancelled
                    )
                  }
                >
                  Refund 10% EMD Amount
                </CButton>

                <br />
                <CButton
                  color="info"
                  className=" ml-2 mr-2 mb-2"
                  hidden={
                    props.viewListDetails.isEMDRefundGenerated ? false : true
                  }
                  onClick={() => {
                    ShowRefundHistory(
                      props.viewListDetails.tenderId,
                      props.viewListDetails.lotNo,
                      2
                    );
                  }}
                >
                  View Refund Status
                </CButton>
              </CCol>
              <CCol
                className="col-5"
                hidden={
                  !props.viewListDetails.islottransferd
                    ? false
                    : props.viewListDetails.lottransfer25emdpaymentCompleted
                    ? true
                    : props.viewListDetails.lottransfer15emdpaymentCompleted ||
                      props.viewListDetails.lottransfer15emdpaymentBGCompleted
                    ? false
                    : true
                }
                // hidden={
                //   props.viewListDetails.lottransfer25emdpaymentCompleted
                //     ? true
                //     : false
                // }
              >
                <strong
                  className="ml-2"
                  hidden={
                    props.viewListDetails.lotTransferCount === 0 &&
                    props.viewListDetails.emdChequeNo !== ""
                      ? true
                      : false
                  }
                >
                  Amount : {props.viewListDetails.amount15}
                </strong>
                <br />
                <CButton
                  className="mt-2 ml-2 mr-2 mb-2"
                  color="success"
                  variant="outline"
                  disabled={
                    props.disableSDRefundButton
                    // props.viewListDetails.disableSDRefundButton ? true : false
                  }
                  hidden={
                    props.viewListDetails.isSDAmountPaidOnline === true
                      ? false
                      : true
                  }
                  // onClick={() =>
                  //   InitiateRefund(
                  //     props.viewListDetails.lotId,
                  //     3,
                  //     props.viewListDetails.lotNo,
                  //     props.viewListDetails.tenderId
                  //   )
                  // }
                  onClick={() =>
                    props.RefundConfirmationPopupHandler(
                      7,
                      1,
                      "Are you sure you want to proceed for Refund?",
                      props.viewListDetails.lotId,
                      props.viewListDetails.lotNo,
                      props.viewListDetails.tenderId,
                      props.viewListDetails.userId,
                      3,
                      props.viewListDetails.isEMDRefundFileCancelled
                    )
                  }
                >
                  Refund 15% Security Deposite
                </CButton>

                <CButton
                  className="mt-2 ml-2 mr-2"
                  color="success"
                  variant="outline"
                  hidden={
                    props.viewListDetails.isSDAmountPaidOnline === true
                      ? true
                      : props.viewListDetails.emdChequeNo !== ""
                      ? true
                      : false
                  }
                  disabled={props.IsSDRefunded === true ? true : false}
                  onClick={() =>
                    props.handleOpenBGRefundPopup(
                      props.viewListDetails.lotId,
                      props.viewListDetails.lotNo,
                      props.viewListDetails.amount15
                    )
                  }
                >
                  Refund 15% Security Deposite via Transfer/BG/FDR
                </CButton>

                <br />
                <CLabel
                  className={"ml-2"}
                  hidden={
                    props.viewListDetails.isSDAmountPaidOnline !== true
                      ? props.viewListDetails.bgRefundComment === ""
                        ? true
                        : false
                      : true
                  }
                >
                  BG Refund Date: <b>{props.viewListDetails.bgRefundDate}</b>
                  <br />
                  Comments: {props.viewListDetails.bgRefundComment}
                </CLabel>
                <br />
                <CButton
                  color="info"
                  hidden={
                    props.viewListDetails.isSDRefundGenerated === true &&
                    props.viewListDetails.isSDAmountPaidOnline
                      ? false
                      : true
                  }
                  onClick={() => {
                    ShowRefundHistory(
                      props.viewListDetails.tenderId,
                      props.viewListDetails.lotNo,
                      3
                    );
                  }}
                >
                  View Refund Status
                </CButton>
              </CCol>
              <CCol
                className="col-3 text-center"
                hidden={
                  props.viewListDetails.lottransfer25emdpaymentCompleted
                    ? false
                    : true
                }
              >
                <strong className="ml-2">
                  Amount : {props.viewListDetails.amount25}
                </strong>
                <br />
                <CButton
                  className="mt-2 ml-2 mr-2 mb-2"
                  color="success"
                  variant="outline"
                  disabled={
                    props.disable25PerSDRefund
                    //props.viewListDetails.disable25PerSDRefund ? true : false
                  }
                  // onClick={() =>
                  //   InitiateRefund(
                  //     props.viewListDetails.lotId,
                  //     6,
                  //     props.viewListDetails.lotNo,
                  //     props.viewListDetails.tenderId
                  //   )
                  // }
                  onClick={() =>
                    props.RefundConfirmationPopupHandler(
                      7,
                      1,
                      "Are you sure you want to proceed for Refund?",
                      props.viewListDetails.lotId,
                      props.viewListDetails.lotNo,
                      props.viewListDetails.tenderId,
                      props.viewListDetails.userId,
                      6,
                      props.viewListDetails.isEMDRefundFileCancelled
                    )
                  }
                >
                  Refund 25% EMD Amount
                </CButton>

                <br />
                <CButton
                  color="info"
                  className=" ml-2 mr-2 mb-2"
                  hidden={
                    props.viewListDetails.is25PerSDRefundGenerated
                      ? false
                      : true
                  }
                  onClick={() => {
                    ShowRefundHistory(
                      props.viewListDetails.tenderId,
                      props.viewListDetails.lotNo,
                      6
                    );
                  }}
                >
                  View Refund Status
                </CButton>
              </CCol>
            </CRow>
          </>
        )}
      {/* End Refund Security Deposite */}
      <ModelRefundHistory
        refundopen={refundopen}
        setrefundopen={setrefundopen}
        handleRefundPopupClose={handleRefundPopupClose}
        tenderid={props.viewListDetails.tenderId}
        lotNo={props.viewListDetails.lotNo}
        refundType={refundType}
        transferFormUserId={transferFormUserId}
        transferCount={transferCount}
      />
    </>
  );
};

export default LotListViewTransferRefund;
